import React, { Fragment, Dispatch, useEffect, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TextField from '@material-ui/core/TextField';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Toolbar from '@material-ui/core/Toolbar';
import Checkbox from '@material-ui/core/Checkbox';
import AddIcon from '@material-ui/icons/Add';
import clsx from 'clsx';
import DeleteIcon from '@material-ui/icons/Delete';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import { getNewBrand, getNewlyAddedBrand } from '../../common/components/util';
import { RESTRICTED_ACCESS } from '../../constants/restrictedAccessConstants';
import _, { get } from "lodash";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import InputAdornment from "@material-ui/core/InputAdornment";
import Snackbar from '../../common/components/CreatedEnquirySnackbar';
import CloseIcon from '@material-ui/icons/Close';
import { AnyRecord } from 'dns';
import { addAnnxurePart } from '../../store/actions/annexureParts.actions';
import WarningIcon from "@material-ui/icons/Warning";
import DialogContentText from '@material-ui/core/DialogContentText';
import { Dialog, FormControl, InputLabel, OutlinedInput, Select } from "@material-ui/core";
import FullscreenLoader from "./../../common/components/FullscreenLoader";
import { Box } from "@material-ui/core";
import { getAnnexureList, updateAnnexurePart, deleteAnnexurePart, editAnnexurePart } from '../../store/actions/annexureParts.actions';
import Tooltip from '@material-ui/core/Tooltip';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ListItemText from '@material-ui/core/ListItemText';
import Menu, { MenuProps } from '@material-ui/core/Menu';
import { getTBLPartsAPI } from '../../store/actions/createUpdateEnquiry.actions';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import { withStyles } from "@material-ui/core/styles";
import { searchProducts } from '../../store/actions/products.actions';
import { getMaterialGroups } from '../../store/actions/materialGroups.actions';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { getManageStock, addNewStockRule } from '../../store/actions/dealer.action';
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';
import Popover from '@material-ui/core/Popover';

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
    },
    table: {
        minWidth: 750,
    },
    icon: {
        float: "left",
        margin: "0 20px 20px 0",
        height: "100%",
        fill: "white",
    },
    header: {
        color: "#133F8A",
        fontWeight: 900,
        fontSize: "0.813rem",
        fontFamily: 'Nunito'
    },
    title: {
        flex: '1 1 100%',
    },
    buttonDel: {
        color: "#1A9FE0",
        fontSize: '0.625rem',
        textTransform: 'capitalize',
        fontFamily: 'Nunito',
        float: 'right'
    },
    logoutText: {
        color: '#616161',
        fontSize: '0.875rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        textTransform: 'inherit',
        textAlign: 'left',        // <-- key change
        lineHeight: '1.6',
        paddingLeft: '8px'        // <-- ensures alignment under the icon
    },
    yes: {
        fontSize: '0.813rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        color: '#1A9FE0',
        textTransform: 'capitalize'
    },
    cancel: {
        fontSize: '0.813rem',
        fontFamily: 'Nunito',
        fontWeight: 700,
        color: '#919191',
        textTransform: 'capitalize'
    },
    buttonIconDel: {
        color: "#1A9FE0",
    },
    buttonExcel: {
        fontSize: '0.75rem',
        textTransform: "none",
        color: "#1A9FE0",
        float: "right",
    },
    buttonAdd: {
        margin: "0.6rem 0.6rem 0.6rem 1.2rem",
        fontSize: 35,
        borderRadius: 45,
        height: 35,
        width: 35,
        textTransform: 'none',
    },
    tablehead: {
        color: "#133F8A",
        fontSize: "0.813rem",
        fontFamily: 'Nunito',
        fontWeight: 900,
    },
    bodyContent: {
        color: '#666666',
        fontSize: '0.813rem',
        fontFamily: 'Nunito',
        fontWeight: 600
    },
    createButton: {
        backgroundColor: '#1A9FE0',
        width: 140,
        fontWeight: 800,
        textTransform: 'inherit',
        fontFamily: 'Nunito',
        fontSize: '0.688rem',
        color: '#FFFFFF',
        borderRadius: '2.5rem',
        height: 35,
        textAlign: 'center',
        marginRight: 8
    },
    closeButton: {
        backgroundColor: '#EAEAEA',
        width: 140,
        fontWeight: 800,
        textTransform: 'capitalize',
        fontFamily: 'Nunito',
        fontSize: '0.688rem',
        color: '#666666',
        borderRadius: '2.5rem',
        height: 35,
        textAlign: 'center',
        marginRight: 24
    },
    addUpdateDailogTitle: {
        position: "absolute",
        top: 10,
        left: 10
    },
}));

const StyledMenu = withStyles({
    paper: {
        border: '1px solid #d3d4d5',
    },
})((props: MenuProps) => (
    <Menu
        elevation={0}
        getContentAnchorEl={null}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
        }}
        {...props}
    />
));


export default function AddNewRuleDialog(props: any) {
    const classes = useStyles();
    const dispatch = useDispatch();

    const [availableParts] = React.useState([
        "01487-14527",
        "17854-14000",
        "08547-00478",
        "14958-05527",
        "58547-00478",
        "00908-14528"
    ]);

    const [selectedPart, setSelectedPart] = React.useState('');
    const [updateStock, setUpdateStock] = React.useState('');
    const [stockError, setStockError] = React.useState('');
    const [partError, setPartError] = React.useState(false);
    const [showCancelDialog, setShowCancelDialog] = React.useState(false);
    const [successMessage, setSuccessMessage] = React.useState('');
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [loading, setLoading] = React.useState<any>(false);
    const [openErrorSnackbar, setOpenErrorSnackbar] = React.useState(false);
    const [showErrorMessage, setShowErrorMessage] = React.useState<any>(null);
    const [selected, setSelected] = React.useState<any>([]);
    const [parts, setParts] = React.useState<any>([]);
    const [brands, setBrands] = React.useState([]);
    const [i, setIndex] = React.useState();
    const [name, setName] = React.useState('');
    const [addPart, setIsAddPart] = React.useState(false);
    const [isGlobalChecked, setIsGlobalChecked] = React.useState(false);
    const { productsData } = useSelector((state: any) => state.products);
    const { createFavorite, favoritesDetails, favoritesList, updateFavorite }: any = useSelector((state: any) => state.favorites);
    const [nameError, showError] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<any>('');
    const [isValid, setIsValid] = React.useState<boolean>(true);
    const { enquirySessionId }: any = useSelector(
        (state: any) => state.createUpdateEnquiry
    );
    const { profileDetails }: any = useSelector((state: any) => state.profileDetails);
    const { materialGroups }: any = useSelector((state: any) => state.materialGroups)
    const customerTierType = get(profileDetails, 'data.data.customerInfo.customerTierType', '');
    const customerTypeAccess = get(profileDetails, 'data.data.basicInfo.customerTypeAccess', '');
    let materialGroupsData = get(materialGroups, 'data.data', []);
    const b2bUserId = get(profileDetails, 'data.data.basicInfo.b2bUserId', "");
    const firstName = get(profileDetails, 'data.data.basicInfo.firstName', "");
    let inputRefs: any = [];
    let sapCustomerId: any = _.get(profileDetails, "data.data.basicInfo.sapCustomerId", "");
    const [partNumber, setPartNumber] = React.useState<any>([]);
    const [brand, setBrand] = React.useState<any>('');
    const [description, setDescription] = React.useState<any>('');
    const [selectedTab, setSelectedTab] = React.useState<any>([]);
    const [isValidPart, setIsValidPart] = React.useState<any>(false);
    const [openDialog, setOpenDialog] = React.useState<any>(false);
    const [partNumberError, setPartNumberError] = React.useState<any>(false);
    const [brandError, setBrandError] = React.useState<any>(false);
    const [descriptionError, setDescriptionError] = React.useState<any>(false);
    const [activeTab, setActiveTab] = React.useState<any>(0);
    const [productList, setProductList] = React.useState<any>([]);
    const webApplicationLoginId: any = sessionStorage.getItem("webApplicationLoginId");
    const [isDataUpdated, setIsDataUpdated] = React.useState(false);
    const rowsPerPage = 10;
    const { getAnnexureListData, editAnnexurePartDetails } = useSelector((state: any) => state.annexure)
    const [displayName, setDisplayName] = React.useState<any>('');
    const [updateFieldEnabled, setUpdateFieldEnabled] = React.useState(false);
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const [selectedPartNumber, setSelectedPartNumber] = React.useState<any>([]);
    const [searchText, setSearchText] = React.useState<any>('');
    const [customerId, setCustomerId] = React.useState<any>([]);
    const { getTBLPartsDetails }: any = useSelector(
        (state: any) => state.createUpdateEnquiry
    );
    const [selectedOfficeTitle, setSelectedOfficeTitle] = React.useState<any>('');
    const [selectedOfficeTypeError, setSelectedOfficeTypeError] = React.useState(false);
    const [selectedCustomerId, setSelectedCustomerId] = React.useState<any>([]);
    const [isDisabled, setIsDisabled] = React.useState<boolean>(false);
    const [isCustomerIDSelected, setIsCustomerIDSelected] = React.useState<boolean>(false);

    const [selectedPartDetails, setSelectedPartDetails] = React.useState<{ partNumber: string; brand: string; orgId: string }>({
        partNumber: '',
        brand: '',
        orgId: ""
    });
    const [isRuleSubmitted, setIsRuleSubmitted] = React.useState<boolean>(false);
    const userName = get(profileDetails, 'data.data.basicInfo.displayName', "");
    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (props.isEdit && props.selectedStockItem) {
            setSelectedCustomerId(props.selectedStockItem.partNumber);
            setUpdateStock(String(props.selectedStockItem.stockPercentage));
            setSelectedPartDetails({
                partNumber: props.selectedStockItem.partNumber,
                brand: props.selectedStockItem.brand,
                orgId: props.selectedStockItem.orgId,
            });
            setUpdateFieldEnabled(true);
        }
    }, [props.isEdit, props.selectedStockItem]);


    const handleopenCloseErrorSnackbar = (open?: any) => {
        setOpenErrorSnackbar(open ? true : false);
    };

    const handleopenCloseSnackbar = (open?: any) => {
        setOpenSnackbar(open ? true : false);
    };

    const handleClose = () => {
        setAnchorEl(null);
        setSearchText("");
    };

    const deduplicatePartsByPartNumber = (parts: any[]) => {
        const seen = new Set<string>();
        const deduped: any[] = [];

        for (const part of parts) {
            const normalized = part.partNumber?.trim().toUpperCase();
            if (normalized && !seen.has(normalized)) {
                seen.add(normalized);
                deduped.push(part);
            }
        }

        return deduped;
    };

    const onSearchCustomerId = (searchText: any) => {
        setSearchText(searchText);

        const rawParts = getTBLPartsDetails?.data?.[0]?.parts || [];
        const zeroStockParts = rawParts.filter((part: any) => String(part.stockPercentage) === "0");

        const dedupedParts = deduplicatePartsByPartNumber(zeroStockParts);

        if (searchText.trim().length > 0) {
            const filtered = dedupedParts.filter((part: any) =>
                part.partNumber?.trim().toLowerCase().includes(searchText.trim().toLowerCase())
            );
            setCustomerId(filtered);
        } else {
            setCustomerId(dedupedParts);
        }
    };

    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);

        const rawParts = getTBLPartsDetails?.data?.[0]?.parts || [];
        const zeroStockParts = rawParts.filter((part: any) => String(part.stockPercentage) === "0");

        const dedupedParts = deduplicatePartsByPartNumber(zeroStockParts);
        setCustomerId(dedupedParts);
    };

    const handleClickSapId = async (event: any, partNumber: string) => {
        setSelectedCustomerId(partNumber);
        setIsDisabled(true);
        setIsCustomerIDSelected(true);
        onCustomerChangeReset();
        setIsDataUpdated(true);
        try {
            const actionResult: any = await dispatch(searchProducts(
                customerTierType,
                partNumber,
                enquirySessionId,
                firstName,
                "",
                b2bUserId,
                [partNumber]
            ));

            const products = actionResult?.data;
            const groups = materialGroups?.data?.data;
            if (!products || !products.length || !groups || !groups.length) {
                return;
            }

            const product = products[0];
            const materialGroupValue = product?.attributes?.materialGroup?.value;
            const description = product?.description?.EN || "";
            if (!materialGroupValue) {
                return;
            }

            let resolvedBrand = "";
            let resolvedOrgId = "";  // variable for orgId

            // Special case handling for ALPOE and AMPTB
            if (materialGroupValue.includes("ALPOE") && description.trim()) {
                resolvedBrand = "ALAC AfterMarket Parts";
                // Try to find orgId from groups that include ALPOE
                const matchedGroup = groups.find((group: any) =>
                    Array.isArray(group.materialGroup) && group.materialGroup.includes("ALPOE")
                );
                resolvedOrgId = matchedGroup?.orgId || "";
            } else if (materialGroupValue.includes("AMPTB") && description.trim()) {
                resolvedBrand = "ALAC Tyres & Batteries";
                // Try to find orgId from groups that include AMPTB
                const matchedGroup = groups.find((group: any) =>
                    Array.isArray(group.materialGroup) && group.materialGroup.includes("AMPTB")
                );
                resolvedOrgId = matchedGroup?.orgId || "";
            } else {
                const prefix = materialGroupValue.substring(0, 5);
                const matchedGroup = groups.find((group: any) =>
                    Array.isArray(group.materialGroup) &&
                    group.materialGroup.includes(prefix)
                );
                resolvedBrand = matchedGroup?.displayName || "";
                resolvedOrgId = matchedGroup?.orgId || "";
            }

            setSelectedPartDetails({
                partNumber,
                brand: resolvedBrand,
                orgId: resolvedOrgId  // include orgId in payload
            });

            setUpdateFieldEnabled(true);
        } catch (error) {
        }
    };

    // const handleSubmitStockRule = () => {
    //     if (!selectedPart) {
    //         setPartError(true);
    //         return;
    //     } else {
    //         setPartError(false);
    //     }

    //     const stockVal = parseInt(updateStock, 10);
    //     if (!updateStock || isNaN(stockVal) || stockVal < 1 || stockVal > 100) {
    //         setStockError('Please enter a valid percentage (1–100).');
    //         return;
    //     }

    //     console.log(`Applying ${stockVal}% stock reduction for part ${selectedPart}`);
    //     setSuccessMessage("Stock update rule added successfully.");
    //     setOpenSnackbar(true);

    //     setSelectedPart('');
    //     setUpdateStock('');
    //     setStockError('');
    //     setPartError(false);
    //     props.setOpenDialog();
    // };

    const onCustomerChangeReset = () => {
        setSelectedOfficeTypeError(false);
    };

    const handleValidateAndSubmit = () => {
        let hasError = false;

        // ✅ Validate Part Number
        if (
            !selectedCustomerId ||
            typeof selectedCustomerId !== "string" ||
            selectedCustomerId.trim() === ""
        ) {
            setPartNumberError(true);
            hasError = true;
        } else {
            setPartNumberError(false);
        }

        // ✅ Validate Stock Percentage
        const stockVal = parseInt(updateStock, 10);
        if (!updateStock || isNaN(stockVal) || stockVal < 1 || stockVal > 100) {
            setStockError("Please enter a valid percentage (1–100).");
            hasError = true;
        } else {
            setStockError("");
        }

        // ✅ Show error snackbar if any validation fails
        if (hasError) {
            setShowErrorMessage("Please fill in all mandatory fields.");
            handleopenCloseErrorSnackbar(true);
            handleopenCloseSnackbar(false);
            return;
        }

        // ✅ On Success
        addNewManageStockRule();
    };

    const addNewManageStockRule = async () => {
        setLoading(true);
        const { partNumber, brand, orgId } = selectedPartDetails;
        const payload = {
            partNumber,
            brand,
            orgId,
            updatedBy: userName,
            stockPercentage: updateStock
        };

        const responseData: any = await dispatch(addNewStockRule(payload));
        if (responseData && responseData.status === 400) {
            setShowErrorMessage(responseData?.error);
            handleopenCloseErrorSnackbar(true);
            handleopenCloseSnackbar(false);
            setLoading(false);
            setIsRuleSubmitted(false);
        } else {
            setLoading(false);
            setSuccessMessage(props.isEdit === true ? "Rule has been updated Successfully." : "Rule has been submitted Successfully.");
            handleopenCloseErrorSnackbar(false);
            setIsRuleSubmitted(true);
            handleopenCloseSnackbar(true);
            setPartNumberError(false);
            setStockError("");
        }
    };

    return (
        <Fragment>
            {loading && <FullscreenLoader />}
            <Snackbar
                open={openSnackbar}
                handleopenClose={() => {
                    handleopenCloseSnackbar(false)
                }} message={successMessage} />
            <Snackbar
                open={openErrorSnackbar}
                type="error"
                handleopenClose={() => {
                    handleopenCloseErrorSnackbar(false)
                }} message={showErrorMessage} />
            <div className={classes.root}>
                <Toolbar
                    className={clsx(classes.root)}>
                    <div className="col-12 mb-3 mt-3">
                        <Typography className={classes.title} variant="h4" id="tableTitle" component="div">
                            <h4 className="shift-to-party-page-title">
                                <div className={classes.addUpdateDailogTitle}>
                                    {props.isEdit === true ? "Edit Rule " : "Add New Rule"}
                                </div>
                                {isRuleSubmitted === false ?
                                    <IconButton aria-label="close" className="float-right" onClick={() => {
                                        if (isDataUpdated === true) {
                                            setOpenDialog(true);
                                        } else {
                                            props.setOpenDialog();
                                        }
                                    }}>
                                        <CloseIcon />
                                    </IconButton>
                                    : ""}
                            </h4>
                        </Typography>
                    </div>
                </Toolbar>
            </div>
            {isRuleSubmitted === false ?
                <div className='pt-3'>
                    <Toolbar className="mb-0 nationality d-flex justify-content-between">
                        {/* Part Number Field */}
                        <div className="col-lg-6 col-md-6 col-sm-12 pr-2">
                            <div style={{ position: 'relative', minHeight: '70px' }}>
                                <TextField
                                    required
                                    id="customerId"
                                    variant="outlined"
                                    size="small"
                                    onClick={handleClick}
                                    disabled={props.isEdit ? true : false}
                                    value={selectedCustomerId}
                                    error={partNumberError}
                                    helperText={partNumberError ? "Part No. is required." : " "} // maintain height with empty string
                                    label="Part No."
                                    placeholder="Select Part"
                                    inputRef={inputRef}
                                    className="smallText mt-2 commonRoundedInputs w-100"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <KeyboardArrowDownIcon fontSize="small" />
                                            </InputAdornment>
                                        ),
                                        style: {
                                            borderRadius: "24px",
                                            backgroundColor: "#fff",
                                            paddingLeft: "14px",
                                        },
                                    }}
                                    InputLabelProps={{
                                        style: {
                                            fontWeight: "bold",
                                            fontSize: "13px",
                                        },
                                    }}
                                />

                                <Popover
                                    open={Boolean(anchorEl)}
                                    anchorEl={anchorEl}
                                    onClose={handleClose}
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    transformOrigin={{ vertical: "top", horizontal: "left" }}
                                    PaperProps={{
                                        style: {
                                            width: inputRef.current?.offsetWidth || 300,
                                            marginTop: "5px",
                                            borderRadius: "16px",
                                            boxShadow: "0px 4px 14px rgba(0,0,0,0.1)",
                                            padding: "8px 0",
                                            maxHeight: customerId?.length > 5 ? 300 : "auto",
                                            overflowY: customerId?.length > 5 ? "auto" : "unset",
                                            zIndex: 1300,
                                        },
                                    }}
                                >
                                    <div className="px-2 pb-2">
                                        <TextField
                                            value={searchText}
                                            onChange={(e) => onSearchCustomerId(e.target.value)}
                                            size="small"
                                            fullWidth
                                            placeholder="Search Part No."
                                            variant="outlined"
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <SearchIcon fontSize="small" />
                                                    </InputAdornment>
                                                ),
                                                style: {
                                                    borderRadius: "24px",
                                                    backgroundColor: "#f4f4f4",
                                                    height: "40px",
                                                    fontSize: "14px",
                                                    paddingLeft: "14px",
                                                },
                                            }}
                                        />
                                    </div>

                                    {customerId && customerId.length > 0 ? (
                                        customerId.map((sapId: any) => (
                                            <Grid key={sapId.partNumber?.trim()} container className="border-bottom">
                                                <MenuItem
                                                    disabled={sapId.isVisible === false}
                                                    value={sapId.partNumber}
                                                    onClick={(event) => {
                                                        handleClickSapId(event, sapId.partNumber);
                                                        setPartNumberError(false);
                                                        handleClose();
                                                    }}
                                                    style={{ fontSize: "14px", padding: "10px 16px" }}
                                                >
                                                    <ListItemText primary={sapId.partNumber} />
                                                </MenuItem>
                                            </Grid>
                                        ))
                                    ) : (
                                        <Grid container>
                                            <div className="d-flex justify-content-center text-center mx-auto py-2">
                                                No part number found.
                                            </div>
                                        </Grid>
                                    )}
                                </Popover>
                            </div>
                        </div>

                        {/* Stock Percentage Field */}
                        <div className="col-lg-6 col-md-6 col-sm-12 pl-2 pt-2">
                            <div style={{ position: 'relative', minHeight: '70px' }}>
                                <TextField
                                    required
                                    label="Update Stock in Percentage"
                                    variant="outlined"
                                    size="small"
                                    value={updateStock}
                                    onChange={(e) => {
                                        setIsDataUpdated(true);
                                        const val = e.target.value;
                                        if (/^(?:[1-9][0-9]?|100)?$/.test(val)) {
                                            setUpdateStock(val);
                                            setStockError('');
                                        }
                                    }}
                                    onBlur={() => {
                                        const numVal = parseInt(updateStock, 10);
                                        if (isNaN(numVal) || numVal < 1 || numVal > 100) {
                                            setUpdateStock('');
                                            setStockError('Please enter a valid percentage (1–100).');
                                        }
                                    }}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">%</InputAdornment>,
                                    }}
                                    error={Boolean(stockError)}
                                    helperText={stockError || ' '} // keep space to prevent layout shift
                                    className="w-100 commonRoundedInputs common-input-font-size"
                                />
                            </div>
                        </div>
                    </Toolbar>
                    <div className="d-flex justify-content-start mb-0 m-0 p-0">
                        <div className='px-4'>
                            <p className="text-note mt-4 px-4">
                                Note: Updated Stock will reduce the stock from the NOW quantity for the selected Part.
                            </p>
                        </div>
                    </div>
                    {/* <div className="d-flex justify-content-between m-0 p-0">
                        <div className="col-lg-6 col-md-6 col-sm-12 pl-2 text-align-left m-0 p-0"></div>
                        <div className="col-lg-6 col-md-6 col-sm-12 pl-2 text-align-left m-0 p-0">
                            <span
                                className="px-2 d-block"
                                style={{
                                    fontSize: '0.75rem',
                                    color: '#5a5a5a',
                                    fontFamily: 'inherit',
                                    lineHeight: '1.4',
                                    marginTop: '0px',
                                    paddingTop: '0px'
                                }}
                            >
                                Updated Stock will reduce the stock from the NOW quantity for the selected Part.
                            </span>
                        </div>
                    </div> */}
                </div>
                : ""}
            {isRuleSubmitted === true ?
                <div className='pt-3'>
                    <div className="d-flex justify-content-center mt-4">
                        <CheckCircleIcon className="quotation-created" fontSize="small" />
                    </div>
                    <DialogContentText id="alert-dialog-description">
                        <div className="mt-2">
                            <h5 className="text-center submit-quotation-dialog-content ">{props.isEdit === true ? "Rule has been updated Successfully." : "Rule has been submitted Successfully."}</h5>
                        </div>
                        <div className="pr-2 mb-2">
                        </div>
                    </DialogContentText>
                </div>
                : ''}
            <div className="form-section p-4">
                <React.Fragment>
                    <Dialog
                        disableBackdropClick={true}
                        open={openDialog}
                        fullWidth={true}
                        maxWidth={'sm'}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogContent>
                            <div className={`mt-2 ${classes.icon}`}>
                                <WarningIcon className="delete-warning" fontSize="small" />
                            </div>
                            <div>
                                <DialogContentText id="alert-dialog-description">
                                    <div className={`mt-4 ${classes.logoutText}`}>
                                        Do you wish to proceed without saving the data ?
                                    </div>
                                </DialogContentText>
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <><Button
                                className={`mx-4 ${classes.yes}`}
                                onClick={async () => {
                                    props.setOpenDialog();
                                    setOpenDialog(false);
                                }}>Proceed</Button>
                                <Button
                                    className={`mr-4 ${classes.cancel}`}
                                    onClick={() => {
                                        setOpenDialog(false);
                                    }}>Cancel</Button></>
                        </DialogActions>
                    </Dialog>
                </React.Fragment>
                {isRuleSubmitted === false ?
                    <DialogActions className="mt-2 justify-content-end mb-2">
                        <Button
                            variant="contained"
                            className="border-left rounded-pill w-150p"
                            color="primary"
                            onClick={handleValidateAndSubmit}
                        >
                            {props.isEdit ? "Update" : "Submit"}
                        </Button>
                        <Button
                            variant="contained"
                            className={classes.closeButton}
                            onClick={() => {
                                if (isDataUpdated === true) {
                                    setOpenDialog(true);
                                } else {
                                    props.setOpenDialog();
                                }
                            }}
                        >
                            Cancel
                        </Button>
                    </DialogActions>
                    : ""}
                {isRuleSubmitted === true ?
                    <DialogActions className="mt-4 justify-content-end mb-2">
                        <Button
                            variant="contained"
                            className={classes.closeButton}
                            onClick={() => {
                                setPartNumberError(false);
                                setStockError("");
                                props.setOpenDialog();
                                dispatch(getManageStock(0, rowsPerPage, ""));
                                dispatch(getTBLPartsAPI());
                            }}
                        >
                            Close
                        </Button>
                    </DialogActions>
                    : ""}
            </div>
        </Fragment >
    );
}
